import SharedMissingFields from 'components/shared/MissingFields';
import { HOME_MANDATORY_FILE_VALIDATIONS } from 'variables/constants';

const MissingFields = () => {
  return (
    <SharedMissingFields
      formStateKey="homePersonalForm"
      mandatoryFileValidations={HOME_MANDATORY_FILE_VALIDATIONS}
    />
  );
};

export default MissingFields;
